<template>
  <div>
    <label>{{ label }}</label>
    <button
      type="button"
      @click="openModal"
      class="btn btn-select-map"
      v-bind:class="{ choose_map_active: isCustom }"
    >
      ✨ GENERATE MY TOY
    </button>
    <modal
      :name="modalName"
      :adaptive="true"
      height="auto"
      width="660px"
      @cancel="handleCancel"
      @before-close="handleCancel"
      :clickToClose="true"
      :reset="true"
      class="Modal_toy_box"
      v-bind:class="{ active: open }"
    >
      <div @click="handleCancel" class="Abn-modal-toy-close">&#10005;</div>
      <div class="Abn-modal-toy-content Abn-modal-toy">
        <div class="toy-group-nav-body">
          <div class="progress-bar-toy">
            <div
              v-for="step in 3"
              :key="step"
              :class="['progress-toy-step', { active: currentStep >= step }]"
            >
              <span>{{ step }}</span>
            </div>
          </div>
          <div class="content-toy">
            <div v-if="currentStep === 1" class="page-toy">
              <div class="group-toy3d">
                <div class="item-control-toy3d">
                  <label :for="layerid + '_type'"
                    >Your Profession<strong class="required_labdel"
                      > *</strong
                    ></label
                  >
                  <select
                    v-model="typeInput"
                    :id="layerid + '_type'"
                    class="form-control"
                    required
                  >
                    <option v-for="type in options" :value="type.value">{{
                      type.label
                    }}</option>
                  </select>
                </div>
                <div class="item-control-toy3d">
                  <label :for="layerid + '_name'"
                    >Your Name<strong class="required_labdel"> *</strong></label
                  >
                  <input
                    v-model="nameInput"
                    type="text"
                    :id="layerid + '_name'"
                    required
                    class="form-control"
                  />
                </div>
                <div class="item-control-toy3d">
                  <label :for="layerid + '_gender'"
                    >Your Gender<strong class="required_labdel"
                      > *</strong
                    ></label
                  >
                  <select
                    v-model="genderInput"
                    :id="layerid + '_gender'"
                    class="form-control"
                    required
                  >
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                  </select>
                </div>
                <div class="item-control-toy3d">
                  <label :for="layerid + '_img'"
                    >Your Image<strong class="required_labdel"> *</strong></label
                  >
                  <input
                    ref="input"
                    type="file"
                    name="image"
                    accept="image/*"
                    @change="changeImageInput"
                  />
                  <img
                    v-if="imageInput && !loading_upload"
                    :src="imageInput"
                    @click="handleChooseImage"
                    class="custom-image"
                  />

                  <button
                    v-if="!imageInput || loading_upload"
                    :disabled="loading_upload"
                    type="button"
                    @click="handleChooseImage"
                    class="btn btn-upload-shape-image"
                  >
                    <font-awesome-icon
                      icon="spinner"
                      class="fa-spin"
                      v-if="loading_upload"
                    />
                    Select image
                  </button>
                </div>
              </div>
            </div>
            <div v-if="currentStep === 2" class="page-toy">
              <div class="loader-container-toy">
                <div class="spinner-toy"></div>
                <div class="title-toy-loading">
                  Creating something magical just for you...
                </div>
                <div class="subtitle-toy-loading">
                  ⏱️ This usually takes 1-2 minutes - please stay with us!
                </div>
              </div>
            </div>
            <div v-if="currentStep === 3" class="page-toy">
              <div class="group-show-image-toy">
                <img
                  class="group-show-image-toy_img"
                  :src="ASSET_URL + '/' + imageOutput"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="navigation" v-if="currentStep != 2">
          <button
            :disabled="currentStep == 2"
            type="button"
            :class="{ visibility_hidden: currentStep == 2 }"
            @click="
              () => {
                if (currentStep == 3) {
                  currentStep = 1
                } else if (currentStep == 1) {
                  handleCancel()
                } else {
                  currentStep -= 1
                }
              }
            "
            class="btn btn-toy-prev"
          >
            {{ currentStep == 1 ? 'Cancel' : 'Prev' }}
          </button>
          <button
            :disabled="isDisabledButton"
            type="button"
            @click="handleGenToy"
            class="btn btn-toy-next"
            v-if="currentStep === 1"
          >
            <font-awesome-icon icon="spinner" class="fa-spin" v-if="loading" />
            Next
          </button>

          <button
            type="button"
            @click="handleAppy"
            class="btn btn-toy-next"
            v-if="currentStep === 3"
          >
            Apply
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { get } from 'lodash'
import { URL_API_TOY_3D, ASSET_URL } from '../../config'
import { v4 as uuidv4 } from 'uuid'
import axios from 'axios'
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: 'ImageToy3D',

  props: {
    context: {
      type: Object,
      required: true
    },
    aspectRatio: {
      type: Number,
      default() {
        return 1
      }
    },
    layer: {
      type: Object,
      required: true
    },
    name: {
      type: String,
      default() {
        return null
      }
    }
  },
  created() {},
  computed: {
    label() {
      return get(this.layer, 'personalized.label', this.layer.title)
    },
    layerid() {
      return get(this.layer, 'id', uuidv4())
    },
    isDisabledButton() {
      const { imageInput, nameInput, typeInput, genderInput, loading } = this
      if (!imageInput || !nameInput || !typeInput || loading || !genderInput) {
        return true
      }
    },
    localStorageName() {
      return this.context.name + '_' + this.product().id
    },
    modalName() {
      return `map-${this.uniqueID(10)}`
    }
  },
  watch: {
    loading(v) {
      if (v) {
        document.querySelector('body').style.overflowY = 'hidden'
      } else {
        document.querySelector('body').style.overflowY = 'auto'
      }
    },
    context(v) {
      const { typeInput, nameInput, imageInput, isCustom, genderInput } = v.model
      if (typeInput) {
        this.typeInput = typeInput
      }
      if(isCustom){
        this.isCustom = isCustom;
      }
      if (nameInput) {
        this.nameInput = nameInput;
      }
      if (imageInput) {
        this.imageInput = imageInput;
      }
      if(genderInput){
        this.genderInput = genderInput;
      }
    }
  },
  data() {
    return {
      ASSET_URL,
      open: false,
      currentStep: 1,
      imageInput: null,
      nameInput: '',
      typeInput: '1',
      genderInput: 'male',
      loading_upload: false,
      isCustom: "",
      imageOutput: '',
      loading: false,
      options: [
        { value: '', label: 'Choose type' },
        { value: '1', label: 'Fire fighter' },
        { value: '2', label: 'Doctor' },
        { value: '3', label: 'Police' },
        { value: '4', label: 'Veterinarian' },
        { value: '5', label: 'Electrician' },
        { value: '6', label: 'Software engineer' },
        { value: '7', label: 'Pilot' },
        { value: '8', label: 'Industrial worker' },
        { value: '9', label: 'Lawyer' },
        { value: '10', label: 'Financial Advisor' },
        { value: '11', label: 'Physician assistant' },
        { value: '12', label: 'Truck driver' },
        { value: '13', label: 'Retail Salesperson' }
      ]
    }
  },
  methods: {
    ...mapGetters(['product', 'getCartData', 'isSaveLocalstorage']),
    ...mapMutations(['setCartDataByKey', 'setIsSaveLocalstorage']),
    uniqueID(length) {
      var result = ''
      var chars =
        '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
      for (var i = length; i > 0; --i)
        result += chars[Math.floor(Math.random() * chars.length)]
      return result
    },
    openModal() {
      this.$modal.show(this.modalName)
      this.open = true
    },
    handleAppy() {
      const { typeInput, nameInput, imageInput, imageOutput, genderInput } = this
      this.setIsSaveLocalstorage(true)
      const file = {
        id: this.context.name,
        key: imageOutput,
        genderInput,
        typeInput,
        nameInput,
        imageInput,
        isCustom: imageOutput
      }
      this.isCustom = imageOutput || true;
      this.context.model = file
      this.$modal.hide(this.modalName);
      this.open = false;
    },
    async handleGenToy() {
      this.loading = true
      this.currentStep = 2
      const { typeInput, nameInput, imageInput, genderInput } = this
      if (!typeInput || !nameInput || !imageInput || !genderInput) {
        alert('Please enter complete information to create image!')
        this.loading = false
        this.currentStep = 1
        return
      }
      const gen = await axios(URL_API_TOY_3D, {
        method: 'POST',
        data: {
          type: typeInput,
          name: nameInput,
          image: imageInput,
          gender: genderInput
        }
      }).then(res => res.data)
      const { url_image, code } = gen
      if (url_image && code == 'ok') {
        this.imageOutput = url_image;
        this.currentStep = 3;
        this.loading = false
        return
      }
      alert('An error occurred, please check and try again.')
      this.loading = false
      this.currentStep = 1
    },
    handleChooseImage(e) {
      if (e) e.preventDefault()

      this.$refs.input.click()
    },
    handleCancel() {
      this.open = false;
      // this.$modal.hide(this.modalName)
    },
    changeImageInput(e) {
      const { upload } = this
      const THIS = this
      const files = e.target.files
      if (files.length <= 0) return
      this.loading_upload = true
      const file = files[0]
      const reader = new FileReader()
      reader.onload = async event => {
        const base64 = event.target.result
        const { key } = await upload(base64)
        const url = ASSET_URL + '/' + key
        THIS.setCartDataByKey({
          key: THIS.localStorageName,
          name: THIS.context.label,
          value: url
        })
        THIS.imageInput = url
        THIS.loading_upload = false
      }
      reader.readAsDataURL(file)
    },
    async upload(base64) {
      var file = await fetch(base64)
        .then(res => res.arrayBuffer())
        .then(buf => new File([buf], 'tmp.png', { type: 'image/png' }))
      var signedUrl = await this.getSignedUrl(file.type)
      await axios
        .put(signedUrl.url, file, {
          headers: {
            'Content-Type': file.type
          }
        })
        .catch(err => console.error(err))
      return { key: signedUrl.key }
    },
    async getSignedUrl(mime) {
      var headers = new Headers()
      headers.append('Content-Type', 'application/json')
      var requestOptions = {
        method: 'GET',
        headers: headers,
        redirect: 'follow'
      }
      var signedUrl = null
      await fetch(
        `${this.$options.AWS_API}/signedUrl?type=${mime}`,
        requestOptions
      )
        .then(response => response.json())
        .then(res => (signedUrl = res))
        .catch(err => console.error(err))
      return signedUrl
    }
  }
}
</script>

<style scoped>
input[type='file'] {
  display: none;
}

img.custom-image {
  display: block;
  width: 100px;
  height: 80px;
  object-fit: contain;
  box-shadow: rgb(0 0 0 / 20%) 0px 0px 2px 1px;
  border-radius: 3px;
  border: 3px solid var(--primary-color, #5c6ac4);
  cursor: pointer;
}
</style>

<style>
.item-control-toy3d {
  margin-bottom: 15px;
}

.item-control-toy3d:last-child {
  margin-bottom: 0px;
}

.choose_map_active {
  background: #26bf31 !important;
  border: 1px solid #26bf31 !important;
  animation-name: animation_button_active;
  animation-duration: 2s;
}

.v-ion-abn {
  width: 16px;
  padding: 0;
  margin: 0;
}

.loader-container-toy {
  background-color: #ffffff;
  padding: 50px 0px;
  border-radius: 20px;
  /* -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1); */
  text-align: center;
  max-width: 100%;
}

.spinner-toy {
  border: 7px solid #eee;
  border-top: 7px solid green;
  border-radius: 50%;
  width: 80px;
  height: 80px;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.title-toy-loading {
  font-size: 18px;
  font-weight: bold;
  color: #1f2937;
  margin-bottom: 10px;
}

.subtitle-toy-loading {
  font-size: 14px;
  color: #6b7280;
}

.group-toy3d {
  background: #ffffff;
  padding: 0px;
  border-radius: 3px;
}
.required_labdel {
  color: red;
}

div#containermap {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  overflow: no-content;
}

.Modal_toy_box > div {
  overflow: auto !important;
  max-width: 100%;
}

.Modal_toy_box .vm--overlay {
  display: none !important;
}

.Modal_toy_box.active .vm--overlay {
  display: block !important;
}

.Abn-modal-toy {
  overflow: auto;
  width: 620px;
  max-width: 100%;
  margin: 0 auto;
}

.Abn-modal-toy-close {
  background: #6e6e6f;
  width: 40px;
  height: 40px;
  text-align: center;
  color: white;
  font-weight: 900;
  position: absolute;
  right: 0;
  font-size: 18px;
  display: flex;
  top: 0px;
  justify-content: center;
  cursor: pointer;
  align-items: center;
  z-index: 9999999999999999999999;
}

.Modal_toy_box {
  height: 99vh !important;
}

.Modal_toy_box > div::-webkit-scrollbar {
  width: 6px;
  background-color: #f5f5f5;
}

.Modal_toy_box > div::-webkit-scrollbar-thumb {
  background-color: #341a1a;
}



.Abn-map-box {
  position: relative;
  margin-top: 7px;
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
}

.message-text-loading {
  color: #e1e1e1;
  font-weight: 500;
  text-shadow: 0px 0px 5px #0000007d;
}

.copper-wrapper {
  display: grid;
  grid-template-columns: auto 120px;
}
.modal-wrapper {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: auto 40px;
}
.modal-wrapper .cropper-wrapper {
  overflow: auto;
}

.Abn-modal-toy-content {
  padding: 20px 0px;
}

.mapboxgl-map {
  overflow: auto !important;
}
.Abn-map-box {
  position: relative;
  margin-top: 7px;
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
}

/*.Abn-map-box:after {*/
/*  content: "";*/
/*  display: block;*/
/*  padding-bottom: 100%;*/
/*}*/

.box_shape_map {
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0.6;
  opacity: 0.7;
  position: absolute;
  top: 0;
  bottom: 0;
}

.box_list_map li:hover {
  color: #018f96;
}

.box_list_map li {
  padding: 5px;
  margin: 3px 0;
  cursor: pointer;
}

.box_list_map input[type='radio'] {
  display: none;
}

.box_list_map input[type='radio']:checked ~ label {
  color: #f6f6f6;
  background: none 0% 0% / auto repeat scroll padding-box border-box #dc3545;
  width: 99% !important;
  padding: 5px !important;
  border-radius: 3px !important;
}

.box_list_map input[type='radio']:checked ~ label::before {
  content: '\2762 ' !important;
}

.message-loading-group {
  position: fixed !important;
  top: 0 !important;
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;
  background: #5b5b5b87 !important;
  z-index: 99999999999 !important;
}

img.custom-image {
  width: 100px;
  height: 80px;
  object-fit: contain;
  box-shadow: rgb(0 0 0 / 20%) 0px 0px 2px 1px;
  border-radius: 3px;
  border: 3px solid #5c6ac4;
  cursor: pointer;
}

.message-loading-div {
  margin: 0 auto !important;
  width: 100% !important;
  text-align: center !important;
  position: absolute !important;
  top: 50% !important;
}

.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.Abn-modal-body {
  position: relative;
}

.box_list_map {
  position: absolute;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 99999;
  background: white;
  border: 1px solid #484747;
  margin-top: 5px;
  border-radius: 5px;
}

.Abn-modal-footer {
  display: flex;
  margin-top: 7px;
  justify-content: space-between;
}
button.btn.Abn-btn-apply {
  background: none 0% 0% / auto repeat scroll padding-box border-box
    rgb(33 171 43) !important;
  color: white !important;
  font-weight: 600 !important;
  width: 49%;
  float: left;
  margin: 0px !important;
}

button.btn.Abn-btn-cancel {
  background: #7b7b7e !important;
  color: white !important;
  font-weight: 600 !important;
  width: 49%;
  float: left;
  margin: 0px !important;
}

.mapboxgl-ctrl-logo {
  display: none !important;
}

.mapboxgl-ctrl-bottom-left {
  display: none !important;
}

.Modal_toy_box {
  overflow: auto !important;
  max-width: 100%;
  top: 5px;
  bottom: 5px;
  top: +100vh;
  transition: 0.7s;
}

.Modal_toy_box.active {
  display: block;
  transition: 0.7s;
  top: 0;
}

.Abn-form-search-map {
  width: 100%;
  outline: none;
  padding: 7px;
  border: 2px solid #66666a;
  border-radius: 5px;
  transition: 0.7s;
}
.Abn-form-search-map:focus {
  border: 2px solid #9e0000;
}

.Abn-modal-title {
  margin-bottom: 10px;
}

.v-ion-abn {
  width: 16px;
  padding: 0;
  margin: 0;
}

.choose_map_active {
  background: #26bf31 !important;
  border: 1px solid #26bf31 !important;
  animation-name: animation_button_active;
  animation-duration: 2s;
}

@keyframes animation_button_active {
  from {
    opacity: 0.1;
  }
  to {
    opacity: 1;
  }
}

.gmnoprint {
  display: none !important;
}

.Abn-modal-footer {
  position: sticky;
  bottom: 0;
  width: 570px;
  margin: auto;
  max-width: 100%;
  background: #ffffff66;
  padding: 5px 0;
}

.visibility_hidden {
  visibility: hidden;
}

/* barr */

.progress-bar-toy {
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  align-items: center;
  padding: 0px;
  position: relative;
  flex-direction: row;
  margin-bottom: 25px;
}
.progress-bar-toy::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 5%;
  right: 5%;
  height: 4px;
  background-color: #e9ecef;
  z-index: 1;
}
.progress-toy-step {
  width: 30px;
  height: 30px;
  background-color: #ccc;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  z-index: 2;
  transition: background-color 0.3s;
}
.progress-toy-step.active {
  background-color: #28a745;
}
.progress-toy-step span {
  font-weight: bold;
}

.content-toy {
  flex: 1;
  padding: 0px;
}

.content-toy input, .content-toy select {
    box-shadow: none;
    border-radius: 3px;
}

.page-toy {
  max-width: 600px;
  margin: 0 auto;
  background: white;
  border-radius: 5px;
}
.form-group {
  margin-bottom: 15px;
  text-align: left;
}
.form-group label {
  display: block;
  margin-bottom: 5px;
}
.form-group input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.form-group button {
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.form-group button:hover {
  background-color: #0056b3;
}
.image-container img {
  max-width: 100%;
  height: auto;
  border-radius: 5px;
}
.navigation {
  padding: 0px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 25px;
}
.navigation button {
  width: 50%;
  background-color: #333;
  color: #fff;
  -webkit-transition: background-color .3s;
  transition: background-color .3s;
  margin: 0;
  border-radius: 3px;
}
.navigation button:hover {
      color: #fff;
}
.navigation button.active {
  background-color: #28a745;
}

button.btn.btn-toy-next {
  background: #28a745;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  margin-left: 10px;
}

.toy-group-nav-body {
  padding: 20px;
  border: 1px solid #dbdbdb;
  border-radius: 10px;
}
.group-show-image-toy {
  overflow: auto;
  width: 100%;
  aspect-ratio: 1 / 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.group-show-image-toy_img {
  height: 100%;
  width: auto;
  border-radius: 7px;
}

@media only screen and (max-width: 739px) {
  .Abn-modal-toy-content {
    padding: 0;
    padding-top: 35px !important;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  }

  .Modal_toy_box > div {
    top: 0 !important;
    bottom: 0 !important;
    height: 100vh !important;
  }

  .toy-group-nav-body{
    border: none;
  }
  .navigation{
    padding: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Formulate/ImageToy3D.vue